import React from 'react'

interface AppErrorBoundaryProps {
    children: React.ReactNode
}

interface AppErrorBoundaryState {
    hasError: boolean
}

class AppErrorBoundary extends React.Component<AppErrorBoundaryProps, AppErrorBoundaryState> {
    public state: AppErrorBoundaryState = {
        hasError: false,
    }

    public static getDerivedStateFromError(): AppErrorBoundaryState {
        return { hasError: true }
    }

    public componentDidCatch(_error: Error, _errorInfo: React.ErrorInfo): void {
        // Intentionally no-op to avoid exposing implementation details.
    }

    public render(): React.ReactNode {
        if (!this.state.hasError) {
            return this.props.children
        }

        return (
            <div className="min-h-screen bg-gradient-to-r from-gray-950 via-gray-900 to-gray-950 px-4 py-12 text-center text-gray-100">
                <div className="mx-auto max-w-xl rounded-xl border border-gray-700 bg-gray-900/80 p-8">
                    <h1 className="text-2xl font-semibold">Something went wrong</h1>
                    <p className="mt-2 text-gray-300">
                        We hit an unexpected error while loading this page.
                    </p>
                    <div className="mt-6 flex flex-col gap-3 sm:flex-row sm:justify-center">
                        <button
                            className="rounded-md bg-emerald-500 px-4 py-2 font-medium text-gray-950 hover:bg-emerald-400"
                            onClick={() => window.location.reload()}
                        >
                            Reload Page
                        </button>
                        <button
                            className="rounded-md border border-gray-500 px-4 py-2 font-medium text-gray-100 hover:bg-gray-800"
                            onClick={() => window.location.assign('/')}
                        >
                            Go Home
                        </button>
                    </div>
                </div>
            </div>
        )
    }
}

export default AppErrorBoundary
